import React, { useState } from "react";
import ShoppingCart from "./ShoppingCart";

const CartIcon = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="header-action nav-cart-button"
        onClick={() => setIsCartOpen(true)}
        aria-label="سبد خرید"
      >
        <span className="icon cart-icon" aria-hidden="true" />
      </button>
      <ShoppingCart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
};

export default CartIcon;
